export default from './typing-list';



// WEBPACK FOOTER //
// ./app/components/typing-list/index.js